import React, { useEffect } from "react";
import { Breadcrumb } from "react-bootstrap";
import classes from "./HeroSection.module.scss";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import { getOnboardingOrFormCtaProps } from "../../../utils/applyCtaButtonProps";
import { useRouter } from "next/router";
import { persistSourceContext } from "../../../utils/b2c/sourceTracking";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../../../utils/b2c/constants";

const HeroSection = ({
  countryData,
  headerHeight,
  setHeaderHeight,
}: {
  countryData: any;
  headerHeight: number | null;
  setHeaderHeight: (height: number) => void;
}) => {
  const router = useRouter();
  const herosectionData = countryData?.heroSection ?? {};

  useEffect(() => {
    const header = document.getElementById("header-navbar");
    if (!header) return;

    const win = window as unknown as Window;

    const measure = () => {
      setHeaderHeight(header.getBoundingClientRect().height);
    };

    measure();

    const ResizeObserverCtor = (globalThis as unknown as { ResizeObserver?: typeof ResizeObserver }).ResizeObserver;

    if (typeof ResizeObserverCtor === "function") {
      const ro = new ResizeObserverCtor(measure);
      ro.observe(header);
      win.addEventListener("resize", measure);
      return () => {
        ro.disconnect();
        win.removeEventListener("resize", measure);
      };
    }

    win.addEventListener("resize", measure);
    return () => {
      win.removeEventListener("resize", measure);
    };
  }, []);

  const heroToOnboardingEnabled = herosectionData?.button?.toOnboardingEnabled;
  const applyCtaButtonProps = getOnboardingOrFormCtaProps(router, {
    btnLink: herosectionData?.button?.link,
    formId: herosectionData?.button?.formId || (heroToOnboardingEnabled ? undefined : "main-enquiry-form"),
    toOnboardingEnabled: heroToOnboardingEnabled,
    sourceUrl: typeof window !== "undefined" ? window.location.pathname : "",
  });

  const ctaBtnClickHandler = (applyCtaButtonProps: any) => (e: React.MouseEvent<HTMLButtonElement>) => {
    if (applyCtaButtonProps.mode === "onboarding") {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible: herosectionData?.button?.nearestOffice ?? true,
        coachingVisible: herosectionData?.button?.lookingForCoaching ?? true,
      });
    }
    applyCtaButtonProps.onClick?.(e);
  };

  return (
    <div style={{ height: `calc(720px - ${headerHeight}px)` }} className={classes["hero-section-container"]}>
      <picture className={classes["picture-bridge"]}>
        <source media="(max-width: 767px)" srcSet={herosectionData?.heroImgLink ?? "/images/golden_gate_bridge.jpg"} />
        <img
          src={herosectionData?.heroImgLink ?? "/images/golden_gate_bridge.jpg"}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width={"100%"}
          height={"100%"}
        />
      </picture>

      <div className={classes["text-content-container"]}>
        <Breadcrumb className={classes["breadcrumb-custom"]}>
          <Breadcrumb.Item className={classes["breadcrumb-item-1"]} href="/study-destinations">
            Study Destination
          </Breadcrumb.Item>
          <Breadcrumb.Item href="" className={classes["breadcrumb-item-2"]}>
            {countryData?.name}
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className={classes["hero-section-title"]} dangerouslySetInnerHTML={{ __html: herosectionData?.title ?? "" }} />

        <button
          onClick={ctaBtnClickHandler(applyCtaButtonProps)}
          className={applyCtaButtonProps.formClassName}
        >
          {herosectionData?.button?.title || "Enquire Now"}
        </button>
      </div>
    </div>
  );
};

export default HeroSection;
